<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('preInvoice.previewPdfFile') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <div id="container">
        <i class="fa fa-spinner spin fa-2x" v-if="printing"></i>
        <iframe :src="src" v-if="!printing"></iframe>
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'preInvoicePreviewPDF',
  props: {
    url: {
      type: String,
      default: null
    },
    inv_id: {
      type: Number
    }
  },
  data() {
    return {
      printing: false,
      src: ''
    }
  },
  created() {
    this.previewPDF()
  },
  methods: {
    previewPDF() {
      if (this.url) {
        this.src = this.url
        return
      }
      this.printing = true
      this.$store
        .dispatch('preInvoice/printPDF', { id: this.inv_id })
        .then(response => {
          this.$toasted.success(response.message)
          this.printing = false
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.printing = false
        })
    }
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 70vh;
  background: black;
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 70vh;
  border: 2px solid #acacac;
}
#container i {
  margin-top: 32vh;
}
</style>
